import DefaultButton from "../../../default-button/DefaultButton";
import Tick from "../../../../assets/icons/Tick";
import Cross from "../../../../assets/icons/Cross";
import { Activity, MeetupsTableItemType } from "../../../../types";
import { simpleGetter } from "../../../../actions/common";
import { activitiesApi } from "../../../../api/api";
import { accessGlobalMiscState } from "../../../../stores/misc";
import { showSnackbar } from "../../../../misc/utils";
type Props = {
  setIsRejectModalOpen: (value: boolean) => void;
  handleApprove: () => void;
};

export default function MeetupsDescrCardButton({
  setIsRejectModalOpen,
  handleApprove,
}: Props) {
  const currentMeet: Activity = accessGlobalMiscState().get('meetupsFormEditItem');

  const updateStatus = (status: number) => async () => {
    const response = await simpleGetter(activitiesApi.createActivity, { id: currentMeet.id, status });
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().setBatch({
        activitiesTriggerFetch: (accessGlobalMiscState().get("activitiesTriggerFetch") || 0) + 1,
        isMeetupsAddFormOpen: false
      })
    }
  }

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full">
      <DefaultButton
        additionalStyle={
          "bg-[#3BBC30] w-full sm:w-1/2 border border-[#3BBC30] rounded-lg"
        }
        buttonText="Одобрить"
        Icon={Tick}
        onClick={updateStatus(1)}
      />
      <DefaultButton
        additionalStyle={
          "bg-[#F12D2D] border border-[#F12D2D] w-full sm:w-1/2 rounded-lg"
        }
        buttonText="Отклонить"
        Icon={Cross}
        onClick={updateStatus(-1)}
      />
    </div>
  );
}
